







































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditTestPaper from "./edit-testPaper.vue";
import CreateTestPaperUs from "./create-testPaperUs.vue";
import DetailTestPaperUs from "./detail-testPaper.vue";

class PageTestPaperRequest extends PageRequest {
  keyword: string;
  ExternalType: number = 0;
  classTypeId: number = 11;
  GradeType: number = 1;
  multiTypeName: string = "";
  parentId?: number;
  HandMadeRandom: number = 1;
  parentName: string = "上级分类";
  categoryId?: number;
  testPaperCreateType: number = 2;
  questionId: string;
  IsAudited: boolean;
}

@Component({
  components: { EditTestPaper, CreateTestPaperUs, DetailTestPaperUs },
})
export default class TestPapers extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageTestPaperRequest = new PageTestPaperRequest();
  editModalShow: boolean = false;
  createModalShow: boolean = false;
  detailModalShow: boolean = false;
  loading: Boolean = false;
  multiTypes: any = [];
  data: any = [];
  valueArray: any = [];
  IsAuditList: any = [
    { value: "null", label: "全部" },
    { value: 1, label: "已审核" },
    { value: 0, label: "待审核" },
  ];
  setisaudit(e) {
    if (e == 1) {
      this.pagerequest.IsAudited = true;
    } else if (e == 0) {
      this.pagerequest.IsAudited = false;
    } else {
      this.$delete(this.pagerequest, "IsAudited"); //删除属性方法
    }
  }
  searchGetpage() {
    this.$store.state.testPaper.currentPage = 1;
    this.getpage();
  }
  detail() {
    this.detailModalShow = true;
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.categoryId = null;
      this.pagerequest.parentName = "";
    }
    this.$store.state.testPaper.currentPage = 1;
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.testPaper.list;
  }
  //get loading() {
  // return this.$store.state.testPaper.loading;
  //}
  create() {
    this.createModalShow = true;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("testPaper/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("testPaper/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    let _this = this;
    _this.loading = true;
    await this.$store
      .dispatch({
        type: "testPaper/getCascader",
        data: this.pagerequest,
      })
      .then((result) => {
        this.data = this.$store.state.testPaper.cascaders.items;
        if (sessionStorage.getItem("isGeneral") == "true") {
          if (this.data.length) {
            this.pagerequest.categoryId = this.data[0].value;
            this.pagerequest.parentName = this.data[0].label;
            this.valueArray.push(this.data[0].value);
          }
        }
        this.getpage();
      });
  }
  async getpage() {
    let _this = this;
    if (!_this.loading) {
      _this.loading = true;
    }
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store
      .dispatch({
        type: "testPaper/getAll",
        data: this.pagerequest,
      })
      .then((res) => {
        _this.loading = false;
      })
      .catch((err) => {});
  }
  get pageSize() {
    return this.$store.state.testPaper.pageSize;
  }
  get totalCount() {
    return this.$store.state.testPaper.totalCount;
  }
  get currentPage() {
    return this.$store.state.testPaper.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  columns = [
    {
      title: "试卷名称",
      key: "name",
      fixed: "left",
      width: 350,
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.name,
                href: "http://www.sxjy.cq.cn/testpaper/" + params.row.id,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.name,
          ),
        ]);
      },
    },
    {
      title: "K币",
      width: 65,
      key: "money",
    },
    {
      title: "学科",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", params.row.categoryLabelList[0]);
      },
    },
    {
      title: "试题数",
      width: 80,
      key: "totalQuestion",
    },
    {
      title: "考试",
      width: 65,
      key: "numberOfExams",
    },

    {
      title: "激活",
      width: 65,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isActive ? "" : "red",
            },
          },
          params.row.isActive ? "是" : "否",
        );
      },
    },
    {
      title: "显示",
      width: 65,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isShow ? "" : "red",
            },
          },
          params.row.isShow ? "是" : "否",
        );
      },
    },
    {
      title: "状态",
      width: 80,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isAudited ? "" : "red",
            },
          },
          params.row.isAudited ? "已审" : "待审",
        );
      },
    },
    {
      title: "导入",
      width: 80,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              color: params.row.isGroup ? "" : "red",
            },
          },
          params.row.isGroup ? "已完成" : "未完成",
        );
      },
    },
    {
      title: "范围",
      width: 65,
      render: (h: any, params: any) => {
        // 先定义类型对应的文字和颜色，便于维护
        const typeConfig = {
          0: { text: "不限", color: "#2d8cf0" },
          1: { text: "对外", color: "" },
          2: { text: "对内", color: "red" },
          3: { text: "内外", color: "#2d8cf0" }, // 3-内外沿用0的颜色，可根据需求调整
        };
        // 获取当前行的类型配置，兜底避免无匹配
        const currentConfig = typeConfig[params.row.externalType] || {
          text: "",
          color: "",
        };

        return h(
          "span",
          {
            style: {
              color: currentConfig.color,
            },
          },
          currentConfig.text,
        );
      },
    },
    {
      title: "发布时间",
      key: "createionDay",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.createionDay).toLocaleDateString(),
        );
      },
    },
    {
      title: "发布人",
      key: "creatorUserName",
      width: 80,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "info",
                size: "small",
                // disabled: !(this.data.length>0),
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store
                    .dispatch({
                      type: "testPaper/get",
                      data: params.row,
                    })
                    .then((result) => {
                      this.detail();
                    });
                },
              },
            },
            "查看",
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("testPaper/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit"),
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，第【" +
                        (params.index + 1) +
                        "】条记录吗？",
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "testPaper/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete"),
          ),
        ]);
      },
    },
  ];
  async created() {
    this.$store.state.testPaper.currentPage = 1;
    this.loadCascaders();
  }
}
